'use strict';

var iso639      = require('cjs-iso-639'),
    sortQuality = require('./sort.quality');

/**
 * Prepare data for files list.
 *
 * @param {Object} video - movie object
 * @param {Object} data - data to prepare
 *
 * @return {Array} prepared data
 */
module.exports = function ( video, data ) {
    var subtitleList = [],
        result = [],
        name, tempLanguage,
        languages, className;

    data = sortQuality(video, data);
    subtitleList = data.subtitles;
    data = data.video;

    data.forEach(function ( item ) {
        languages = [];
        item.subtitleList = subtitleList;
        if ( item.languages.length ) {
            item.languages.forEach(function ( language ) {
                tempLanguage = iso639['1'][language] ||
                    iso639['2B'][language] ||
                    iso639['2T'][language];

                if ( tempLanguage ) {
                    languages.push(tempLanguage[1]);
                } else {
                    languages.push(language || gettext('Unknown language'));
                }
            });

            languages = languages.join(', ');
        } else {
            languages = gettext('Unknown language');
        }

        switch ( item['watched_status'] ) {
            case 'watched':
                className = 'theme-icon theme-icon-ok';
                break;
            case 'not_watched':
                className = 'theme-icon theme-icon-ok hidden';
                break;
            case 'not_ended':
                className = 'theme-icon theme-icon-ok disabled';
                break;
        }

        if ( item.quality ) {
            name = (item.quality.code ? item.quality.code + ' (' : '(')
                + (item.quality.name || gettext('Unknown quality')) + ')';
        } else {
            name = '(' + gettext('Unknown quality') + ')';
        }

        result.push({
            items: [
                {
                    className: 'title',
                    value: languages + ' ' + name
                },
                {
                    className: className
                }
            ],
            value: item
        });
    });

    return result;
};
